import React, { Component, CSSProperties, RefObject } from 'react';

import style from './Allergen.module.scss';
import classNames from 'classnames';

interface Props {
  data: {
    value: string;
    label: string;
    icon?: string;
  };
  innerProps: {
    className?: string;
  };
  innerRef: RefObject<HTMLDivElement>;
  getStyles: (id: string, props: {}) => CSSProperties;
}

class AllergenOption extends Component<Props> {
  render() {
    const { data, innerProps, innerRef, getStyles } = this.props;
    const { label, icon } = data;

    const styles = getStyles?.('option', this.props);

    return (
      <div
        ref={innerRef}
        style={styles}
        {...innerProps}
        className={classNames(innerProps.className, style.allergenOption)}
      >
        <img src={icon} alt="icon" className={style.icon} />
        <span className={style.title}>{label}</span>
      </div>
    );
  }
}

export default AllergenOption;
